import React, { useEffect, useState } from 'react';
import { supabase } from '../../../supabaseClient';

export default function EnquiriesTab() {
    const [enquiries, setEnquiries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchEnquiries();
    }, []);

    const fetchEnquiries = async () => {
        setLoading(true);
        const { data, error } = await supabase
            .from('enquiries')
            .select('*')
            .order('created_at', { ascending: false });

        if (error) {
            setError(error.message);
        } else {
            setEnquiries(data || []);
        }
        setLoading(false);
    };

    return (
        <>
            {error && <div className="alert alert-danger">{error}</div>}
            
            <div className="card shadow-lg border-0 rounded-4" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)' }}>
                <div className="card-header border-0 bg-transparent py-4 px-4 d-flex justify-content-between align-items-center">
                    <h4 className="text-white m-0" style={{ fontFamily: 'var(--eventflow-font)', fontWeight: 700 }}>Contact Enquiries</h4>
                    <button onClick={fetchEnquiries} className="btn btn-sm text-white" style={{ background: 'rgba(255,255,255,0.1)' }}>
                        <i className="fa fa-refresh me-2"></i>Refresh
                    </button>
                </div>
                
                <div className="card-body p-0">
                    {loading ? (
                        <div className="text-center py-5 text-white">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : enquiries.length === 0 ? (
                        <div className="text-center py-5" style={{ color: 'rgba(255,255,255,0.5)' }}>
                            No enquiries found.
                        </div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-dark table-hover mb-0" style={{ background: 'transparent' }}>
                                <thead style={{ background: 'rgba(255,255,255,0.05)' }}>
                                    <tr>
                                        <th className="px-4 py-3 border-0 text-uppercase" style={{ color: 'rgba(255,255,255,0.5)', fontSize: '12px', letterSpacing: '1px' }}>Date</th>
                                        <th className="px-4 py-3 border-0 text-uppercase" style={{ color: 'rgba(255,255,255,0.5)', fontSize: '12px', letterSpacing: '1px' }}>Name</th>
                                        <th className="px-4 py-3 border-0 text-uppercase" style={{ color: 'rgba(255,255,255,0.5)', fontSize: '12px', letterSpacing: '1px' }}>Email</th>
                                        <th className="px-4 py-3 border-0 text-uppercase" style={{ color: 'rgba(255,255,255,0.5)', fontSize: '12px', letterSpacing: '1px' }}>Topic</th>
                                        <th className="px-4 py-3 border-0 text-uppercase" style={{ color: 'rgba(255,255,255,0.5)', fontSize: '12px', letterSpacing: '1px' }}>Message</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {enquiries.map((enquiry) => (
                                        <tr key={enquiry.id} style={{ borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                                            <td className="px-4 py-3 text-white" style={{ verticalAlign: 'middle', whiteSpace: 'nowrap' }}>
                                                {new Date(enquiry.created_at).toLocaleDateString()}
                                            </td>
                                            <td className="px-4 py-3 text-white fw-bold" style={{ verticalAlign: 'middle' }}>{enquiry.name}</td>
                                            <td className="px-4 py-3" style={{ verticalAlign: 'middle', color: 'rgba(255,255,255,0.7)' }}>
                                                <a href={`mailto:${enquiry.email}`} style={{ color: 'var(--eventflow-base)', textDecoration: 'none' }}>{enquiry.email}</a>
                                            </td>
                                            <td className="px-4 py-3 text-white" style={{ verticalAlign: 'middle' }}>
                                                <span className="badge" style={{ background: 'rgba(var(--eventflow-primary-rgb),0.2)', color: 'var(--eventflow-primary)' }}>
                                                    {enquiry.topic}
                                                </span>
                                            </td>
                                            <td className="px-4 py-3 text-white" style={{ verticalAlign: 'middle', maxWidth: '400px' }}>
                                                {enquiry.message}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
